import StorageService from './storageService';
import { SEED_MENU, SEED_REVIEWS } from '../data/seedData';
import { DEFAULT_HERO_IMAGES } from '../data/heroImages';
import { DEFAULT_BUSINESS, mergeBusiness } from '../data/businessDefaults';

const KEYS = {
  MENU: 'te_menu',
  ORDERS: 'te_orders',
  REVIEWS: 'te_reviews',
  HERO_IMAGES: 'te_hero_images',
  ADMIN_PASS: 'te_admin_pass',
  SEEDED: 'te_seeded_v3',
  BUSINESS: 'te_business',
};

export { KEYS };

/**
 * Seed localStorage with demo data on first run.
 * Changing SEEDED key version forces a re-seed on next load.
 */
export async function initAppData() {
  const seeded = await StorageService.get(KEYS.SEEDED);
  if (!seeded) {
    await StorageService.bootstrap({
      menu: SEED_MENU,
      reviews: SEED_REVIEWS,
      orders: [],
      adminPassword: 'admin2025',
    });
  }

  const heroImages = await StorageService.get(KEYS.HERO_IMAGES);
  if (!Array.isArray(heroImages) || heroImages.length < 1) {
    await StorageService.set(KEYS.HERO_IMAGES, DEFAULT_HERO_IMAGES);
  } else if (heroImages.length > 5) {
    await StorageService.set(KEYS.HERO_IMAGES, heroImages.slice(0, 5));
  }

  const businessRaw = await StorageService.get(KEYS.BUSINESS);
  if (businessRaw == null || typeof businessRaw !== 'object') {
    await StorageService.set(KEYS.BUSINESS, mergeBusiness(DEFAULT_BUSINESS));
  }
}
